import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInWithGoogleMutationVariables = Types.Exact<{
  input: Types.SignInWithGoogleRequest;
}>;

export type SignInWithGoogleMutation = {
  __typename?: 'Mutation';
  signInWithGoogle: {
    __typename?: 'SignInWithGoogleResponse';
    message: string;
    success: boolean;
    refreshToken: string;
    accessToken: string;
  };
};

export const SignInWithGoogleDocument = gql`
  mutation SignInWithGoogle($input: SignInWithGoogleRequest!) {
    signInWithGoogle(input: $input) {
      message
      success
      refreshToken
      accessToken
    }
  }
`;
export type SignInWithGoogleMutationFn = Apollo.MutationFunction<
  SignInWithGoogleMutation,
  SignInWithGoogleMutationVariables
>;
export function useSignInWithGoogleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignInWithGoogleMutation,
    SignInWithGoogleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignInWithGoogleMutation,
    SignInWithGoogleMutationVariables
  >(SignInWithGoogleDocument, options);
}
export type SignInWithGoogleMutationHookResult = ReturnType<
  typeof useSignInWithGoogleMutation
>;
export type SignInWithGoogleMutationResult =
  Apollo.MutationResult<SignInWithGoogleMutation>;
export type SignInWithGoogleMutationOptions = Apollo.BaseMutationOptions<
  SignInWithGoogleMutation,
  SignInWithGoogleMutationVariables
>;
